import moment from 'jalali-moment';
import React, { useState } from 'react';
import { Box, Button, Calendar, Grid, Image, Modal, Select, TextField } from '@iho-design-system/Loader';
import CalendarSVG from '../../assets/images/icons/calendar-blue.svg';
import CloseSVG from '../../assets/images/icons/close.svg';
import SearchSVG from '../../assets/images/icons/search.svg';

const Toolbar = ({ requestIdSearchProps, advancedSearchProps, reloadRequestProps }) => {
  const [advancedSearchDate, setAdvancedSearchDate] = useState('');
  const [requestIdSearchKey, setRequestIdSearchKey] = useState({ value: '', color: 'gray' });
  const [advancedSearchData, setAdvancedsearchData] = useState({ RequestKey: -1, TicketStatus: -1 });
  const [disabled, setDisabled] = useState(false);    
    React.useEffect(() => {
        if (requestIdSearchKey.value || advancedSearchData.RequestKey != -1 || advancedSearchData.TicketStatus != -1 || advancedSearchDate) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    }, [requestIdSearchKey, advancedSearchData, advancedSearchDate]);
  const handleRequestIdChange = (value) => {
    const valid = /^[\u06F0-\u06F90-9]*$/.test(value);
    setRequestIdSearchKey({ value, color: valid ? 'gray' : 'danger' });
  };

  const requestIdSearch = () => requestIdSearchProps(requestIdSearchKey.value);

  const handleAdvancedChange = (key, value) => {
    setAdvancedsearchData({ ...advancedSearchData, [key === 'requestKey' ? 'RequestKey' : 'TicketStatus']: value });
  };

  const advancedSearch = () => {
    const data = {
      ...advancedSearchData,
      AddDate: advancedSearchDate
        ? moment.from(advancedSearchDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
        : '',
    };
    advancedSearchProps(data);
    closeModal('searchModal');
  };

  const toggleCalendar = (event, calendar) => {
    if (event.target.tagName === 'INPUT') setAdvancedSearchDate('');
    document.querySelector(`.${calendar}`)?.classList.toggle('d-none');
  };

  const clearDate = () => setAdvancedSearchDate('');
  const unsetFilter = () => {
    setRequestIdSearchKey({ value: '', color: 'gray' });
    setAdvancedsearchData({ RequestKey: -1, TicketStatus: -1 });
    setAdvancedSearchDate('');
    reloadRequestProps(Math.floor(Math.random() * 100));
  };

  const toggleSearchBox = (event) => {
    const parent = event.target.closest('.parent-class');
    const slideUp = parent.querySelector('.slide-up');
    const slideDown = parent.querySelector('.slide-down');
    if (slideUp) slideUp.classList.replace('slide-up', 'slide-down');
    else slideDown?.classList.replace('slide-down', 'slide-up');
  };

  const openModal = (modal) => document.querySelector(`.${modal}`)?.classList.remove('d-none');
  const closeModal = (modal) => document.querySelector(`.${modal}`)?.classList.add('d-none');

  const screenWidth = window.innerWidth;
  const scale =
    screenWidth > 1400
      ? 'xx-large'
      : screenWidth > 1200
      ? 'x-large'
      : screenWidth > 992
      ? 'large'
      : screenWidth > 768
      ? 'medium'
      : screenWidth > 576
      ? 'small'
      : 'x-small';

  const requestTypes = [
    { value: -1, label: 'همه درخواست‌ها' },
    { value: 0, label: 'تغییر یا حذف اتاق' },
    { value: 1, label: 'کنسل کردن رزرو' },
    { value: 2, label: 'تغییر تاریخ رزرو' },
    { value: 3, label: 'افزودن نفر اضافه' },
    { value: 4, label: 'افزودن نیم شارژ' },
    { value: 6, label: 'تغییر اطلاعات مسافران' },
    { value: 8, label: 'ترنسفر' },
  ];

  const ticketStatuses = [
    { value: -1, label: 'همه وضعیت ها' },
    { value: 0, label: 'در انتظار بررسی' },
    { value: 2, label: 'در حال بررسی' },
    { value: 1, label: 'پاسخ داده شده' },
    { value: 'Canceled', label: 'لغو شده' },
  ];

  return (
    <Box className="parent-class">
      <Grid>
        <Grid.Wrapper>
          <Grid.Item className="position-relative" size="col-8 md-4">
            <TextField
              onChange={handleRequestIdChange}
              placeholder="جستجو بر اساس کد درخواست یا کد پیگیری رزرو"
              value={requestIdSearchKey.value}
            />
            <Button
              onClick={requestIdSearchKey.color === 'gray' ? requestIdSearch : undefined}
              variant="light"
              color={requestIdSearchKey.color}
              size="sm"
              ms={{ position: 'absolute', top: '12px', left: '12px' }}
            >
              <Image src={SearchSVG} />
            </Button>
          </Grid.Item>

          <Grid.Item className="text-left" size="col-4 md-8">
            {scale !== 'x-small' ? (
              <>
                <Button onClick={unsetFilter} disabled={disabled} className="unsetFilter mx-sm mr-0" color="danger">
                  حذف فیلترها
                </Button>
                <Button onClick={toggleSearchBox} color="primary">
                  جستجوی پیشرفته
                </Button>
              </>
            ) : (
              <Button onClick={() => openModal('searchModal')} color="primary">
                فیلترها
              </Button>
            )}
          </Grid.Item>
        </Grid.Wrapper>
      </Grid>

      <Grid>
        <Grid.Wrapper className="slide-up">
          <Grid.Item size="col-3">
            <Select
              onChange={(v) => handleAdvancedChange('requestKey', v)}
              label="نوع درخواست"
              init={advancedSearchData.RequestKey}
              readonly
            >
              {requestTypes.map((r) => (
                <Select.Item key={r.value} value={r.value}>
                  {r.label}
                </Select.Item>
              ))}
            </Select>
          </Grid.Item>

          <Grid.Item size="col-3">
            <Select
              onChange={(v) => handleAdvancedChange('ticketStatus', v)}
              label="وضعیت"
              init={advancedSearchData.TicketStatus}
              readonly
            >
              {ticketStatuses.map((t) => (
                <Select.Item key={t.value} value={t.value}>
                  {t.label}
                </Select.Item>
              ))}
            </Select>
          </Grid.Item>

          <Grid.Item className="position-relative" size="col-3">
            <Box onClick={(e) => toggleCalendar(e, 'advancedSearchDate')}>
              <TextField label="تاریخ ثبت" value={advancedSearchDate} placeholder="روز/ماه/سال" ms={{ input: { paddingRight: '35px' } }} />
              <Image className="pointer position-absolute" src={CalendarSVG} ms={{ width: '16px', height: '16px', top: '47px', right: '20px' }} />
              {advancedSearchDate && (
                <Image onClick={clearDate} className="pointer position-absolute" src={CloseSVG} ms={{ width: '16px', height: '16px', top: '47px', left: '20px' }} />
              )}
              <Box className="advancedSearchDate d-none position-absolute" ms={{ width: '320px', top: 'calc(75px + var(--sizing-xs))', zIndex: '1' }}>
                <Calendar onChange={setAdvancedSearchDate} />
              </Box>
            </Box>
          </Grid.Item>

          <Grid.Item size="col-3">
            <Button onClick={advancedSearch} variant="filled" color="primary" ms={{ marginTop: '28px', float: 'left' }}>
              جستجو
            </Button>
          </Grid.Item>
        </Grid.Wrapper>
      </Grid>

      <Modal className="searchModal">
        <Modal.Wrapper size="xs" ms={{ '@media(min-width:576px)': { width: '360px !important' }, '@media(max-width:576px)': { width: 'calc(100% - 12px) !important' } }}>
          <Modal.Header>
            <Box />
          </Modal.Header>
          <Grid>
            <Grid.Wrapper>
              <Grid.Item size="col-12">
                <Select onChange={(v) => handleAdvancedChange('requestKey', v)} placeholder="نوع درخواست" init={advancedSearchData.RequestKey} readonly>
                  {requestTypes.map((r) => (
                    <Select.Item key={r.value} value={r.value}>
                      {r.label}
                    </Select.Item>
                  ))}
                </Select>
              </Grid.Item>
              <Grid.Item size="col-12">
                <Select onChange={(v) => handleAdvancedChange('ticketStatus', v)} disabled={disabled} placeholder="وضعیت" init={advancedSearchData.TicketStatus} readonly>
                  {ticketStatuses.map((t) => (
                    <Select.Item key={t.value} value={t.value}>
                      {t.label}
                    </Select.Item>
                  ))}
                </Select>
              </Grid.Item>
              <Grid.Item className="position-relative" size="col-12">
                <Box onClick={(e) => toggleCalendar(e, 'advancedSearchDateMobile')}>
                  <TextField value={advancedSearchDate} placeholder="روز/ماه/سال" ms={{ input: { paddingRight: '35px' } }} />
                  <Image className="pointer position-absolute" src={CalendarSVG} ms={{ width: '16px', height: '16px', top: '20px', right: '20px' }} />
                  {advancedSearchDate && (
                    <Image onClick={clearDate} className="pointer position-absolute" src={CloseSVG} ms={{ width: '16px', height: '16px', top: '20px', left: '20px' }} />
                  )}
                  <Box className="advancedSearchDateMobile d-none position-absolute" ms={{ width: '260px', transform: 'translate(-50%, -50%)', top: '50%', left: '50%', zIndex: '1' }}>
                    <Calendar onChange={setAdvancedSearchDate} />
                  </Box>
                </Box>
              </Grid.Item>
              <Grid.Item size="col-7">
                <Button onClick={advancedSearch} className="w-100" variant="filled" color="primary">
                  جستجو
                </Button>
              </Grid.Item>
              <Grid.Item size="col-5">
                <Button onClick={unsetFilter} className="w-100" variant="outlined" color="danger">
                  حذف فیلترها
                </Button>
              </Grid.Item>
            </Grid.Wrapper>
          </Grid>
        </Modal.Wrapper>
      </Modal>
    </Box>
  );
};

export default Toolbar;
